export default "__VITE_ASSET__DAGNYnHp__"